import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  appSnackbar: {
    color: '#FFF',
  },
  container: {
    background: theme.palette.custom.background.app,
    height: '100vh',
    width: '100vw',
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
  },
}));

export default styles;
